"use client";

/**
 * PostDetailHeroMedia 컴포넌트
 * @description 글머리의 대표 그림 — 매거진의 첫 장. 조판 폭(1100) 안에서 어느 화면이든
 *   1:1 로 선다. 스크롤에 맞춰 그림이 느리게 따라온다(`useParallax`). 그림이 없으면
 *   세우지 않는다.
 */
import { Media } from "@fanwork-web/design-system";
import { memo } from "react";

import { POST_HERO_SIZES, postDetailStyles } from "./PostDetail.styles";
import type { PostDetailHeroMediaProps } from "./PostDetail.types";

import { AppImage, useParallax } from "@/shared/ui";

const PostDetailHeroMedia = memo<PostDetailHeroMediaProps>(({ post }) => {
  const ref = useParallax<HTMLDivElement>();
  if (!post.coverImageUrl) return null;
  return (
    <div ref={ref} className={postDetailStyles.hero}>
      <Media
        ratio="square"
        slot={
          <AppImage uri={post.coverImageUrl} sizes={POST_HERO_SIZES} priority />
        }
      />
    </div>
  );
});

PostDetailHeroMedia.displayName = "PostDetailHeroMedia";

export default PostDetailHeroMedia;
